import React, { useEffect, useMemo, useState, useRef } from "react";
// import PageHeader from "../../components/PageHeader/PageHeader";
import PageHeader from "../../Components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
// import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import "./NotificationAdd.css";
import moment from "moment";
// import usePermission from "../../customHook/usePermission";
import usePermission from "../../Components/customHook/usePermission";
import Header from "../../Components/Header";
import MaterialTable from "../../Components/Table/MaterialTable";
import { tableEye } from "../../common/Assets/imgs";
const PushNotification = () => {
  const location = useLocation();
  // const [page, setPage] = useState(location?.state?.page || 1);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [adminList, setAdminList] = useState([
    // {
    //   sno: "01",
    //   adminId: "KD075821",
    //   adminName: "Vikram",
    //   role: "Admin",
    //   mobile: "+91 8965346856",
    //   status: "Active",
    //   DateTime:"10-12-2025,1:00 PM",
    // },
    // {
    //   sno: "02",
    //   adminId: "KD075822",
    //   adminName: "Surya",
    //   role: "Super Admin",
    //   mobile: "+91 8965346856",
    //   status: "Active",
    //   DateTime:"10-12-2025,1:00 PM",
    // },
    // {
    //   sno: "03",
    //   adminId: "KD075823",
    //   adminName: "Ajay",
    //   role: "Sub Admin",
    //   mobile: "+91 8965346856",
    //   status: "De-Active",
    //   DateTime:"10-12-2025,1:00 PM",
    // },
  ]);
  const [totalCount, setTotalCount] = useState(0);
  //  const [pagination, setPagination] = useState(1);
  const [search,setSearch]=useState("");
   const [page,setPage]=useState(1);
   const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages,setTotalPages]=useState(1);

  const navigate = useNavigate();
  const permission = usePermission();

  const pageRef = useRef(page);

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  const handleView = (row) => {
    if (!row) return;
    console.log("SDSADL", row);
    navigate("/notification-add", {
      state: { data: row, mode: "view", page: pageRef.current },
    });
  };

   const pageSize = 20;
  const columns = [
    {
      header: "S.No",
           accessorFn: (row, index) =>
    (currentPage - 1) * pageSize + index + 1,
      // accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    //   {
    //     accessorKey: "admin_code",
    //     header: "Admin ID",
    //   },
    {
      accessorKey: "title",
      header: "Notifications",
    },
    // {
    //   accessorKey: "role",
    //   header: "User",
    // },
    // {
    //   accessorKey: "DateTime",
    //   header: "Date & Time",
    // },

    //    {
    //       header: "Status",
    //       accessorKey: "status",
    //       Cell: ({ cell, row }) => {
    //         return (
    //           <button
    //             className={`border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
    //           ${cell.getValue() ? "active-btn" : "deactive-btn"} `}
    //             onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
    //           >
    //             {cell.getValue() ? "Active" : "Deactive"}
    //           </button>
    //         );
    //       },
    //     },
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => {
        console.log('Row Data',row.original);
        console.log('id',row.original.id);
        
        return (
        <div
          onClick={() =>
            navigate("/addpush-notification", {
              state: { data: row.original,
                id:row.original.id,
                 mode: "view",
                // type:"view" 
                },
            })
          }
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      )
    }
    },
  ];

  
  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const fetchNotification = async (page,src) => {
    try {
      setLoader(true);
      let res = await get(
        `${URLS.PUSH_NOTIFICATION_LIST}?page=${page || 1}&search=${src || ""}`,
        // `${URLS.PUSH_NOTIFICATION_LIST}?page=${page || 1}&search=${searchText || ""}`,
      );
      console.log("Notification list res:", res);

      if (res?.status === "success") {
        // setData(res?.data || []);
        setAdminList(res?.data || []);
        setTotalCount(res?.count || 0);
          setCurrentPage(res?.current_page || page);
        // setTotalPages(res?.total_pages || 1);
        // setPagination({
        //   current_page: res?.current_page || 1,
        //   last_page: res?.total_pages || 1,
        // });
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      // setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchNotification(page,search);
  }, [page,search]); 

  // useEffect(() => {
  //   fetchNotification();
  // }, [page, searchText]);

  return (
    <>
      <Header title={"Push Notification"} />
      <div
        style={{ marginTop: "5rem", paddingLeft: "10px", paddingRight: "10px" }}
      >
        <PageHeader
          title="Push Notifications"
          buttonText="+Add Push Notifications"
          buttonPath="/notification-add"
          permissionAllowed={"CAN-ADD-PUSH_NOTIFICATION"}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
            Total: {totalCount || 0}
          </h2>
          {/* <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search description"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div> */}

          <div>
            {/* ADD BUTTON */}
            <button
              onClick={() =>
                navigate("/addpush-notification", {
                  state: {
                    type: "add",
                  },
                })
              }
              style={{ backgroundColor: "#F98425" }}
              className="btn text-white fw-semibold px-4 py-2"
            >
              + Add Push Notifications
            </button>
          </div>
        </div>
      </div>
      {/* <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      /> */}
      <div className="px-3">
        <MaterialTable
          columns={columns}
          loading={loader}
          data={adminList || []}
          // pagination={pagination}
          // setPagination={setPagination}
          pagination={page}
          setPagination={setPage}
           rowCount={totalCount}  
          // totalPages={totalPages}
          // totalPages={pagination?.last_page}
        />
      </div>
    </>
  );
};

export default PushNotification;
